const initTrainingWizard = () => {
    let animating = false;

    const fieldsets = Array.from(document.querySelectorAll(".training fieldset"));
    const totalSteps = fieldsets.length;
    let currentStep = 1;

    // Custom progress bar percentages for each step
    const stepPercentages = [10, 45, 90, 100];

    const progressBar = document.getElementById("progress-bar");
    const resetButton = document.getElementById("reset");

    const getCurrentVisibleFieldset = () =>
        fieldsets.find((fs) => {
            // Prefer computed style in case "display" is controlled by CSS.
            const style = window.getComputedStyle(fs);
            return style.display !== "none" && style.visibility !== "hidden";
        });

    const setProgressBar = (step) => {
        const index = step - 1;
        const percent = index >= 0 && index < stepPercentages.length
            ? stepPercentages[index]
            : 100;

        if (progressBar) progressBar.style.width = `${percent}%`;
    };

    const showInline = (el) => {
        if (!el) return;
        el.style.display = "inline-block";
    };

    const hide = (el) => {
        if (!el) return;
        el.style.display = "none";
    };

    const show = (el) => {
        if (!el) return;
        el.style.display = "";
    };

    // Approximation of "easeInOutBack"
    const easing = "cubic-bezier(0.68,-0.55,0.265,1.55)";
    const duration = 650;

    const transitionTo = async ({ from, to, direction }) => {
        if (!from || !to) return;
        if (animating) return;

        animating = true;

        show(to);

        from.style.position = "absolute";

        to.style.position = "relative";

        to.style.left = direction === "next" ? "0%" : "0%";
        to.style.opacity = "1";
        to.style.transform = direction === "next" ? "none" : "scale(0.8)";

        const fromKeyframes =
            direction === "next"
                ? [
                    { opacity: 1, transform: "scale(1)", left: "0%" },
                    { opacity: 0, transform: "scale(0.8)", left: "0%" },
                ]
                : [
                    { opacity: 1, transform: "none", left: "0%" },
                    { opacity: 0, transform: "none", left: "50%" },
                ];

        const toKeyframes =
            direction === "next"
                ? [
                    { opacity: 0, left: "50%", transform: "none" },
                    { opacity: 1, left: "0%", transform: "none" },
                ]
                : [
                    { opacity: 0, transform: "scale(0.8)", left: "0%" },
                    { opacity: 1, transform: "scale(1)", left: "0%" },
                ];

        const fromAnim = from.animate(fromKeyframes, { duration, easing, fill: "forwards" });
        const toAnim = to.animate(toKeyframes, { duration, easing, fill: "forwards" });

        try {
            await Promise.all([fromAnim.finished, toAnim.finished]);
        } finally {
            hide(from);

            // Reset styles to prevent accumulation
            from.style.opacity = "";
            from.style.transform = "";
            from.style.left = "";
            from.style.position = "";

            to.style.opacity = "";
            to.style.transform = "";
            to.style.left = "";
            to.style.position = "relative";

            animating = false;
        }
    };

    // Event delegation for .next / .previous / .submit
    document.addEventListener("click", async (e) => {
        const nextBtn = e.target.closest(".next");
        const prevBtn = e.target.closest(".previous");
        const submitBtn = e.target.closest(".submit");
        const resetBtn = e.target.closest("#reset");

        if (submitBtn) {
            e.preventDefault();
            return;
        }

        if (nextBtn) {
            e.preventDefault();

            showInline(resetButton);

            if (animating) return;

            const currentFs = nextBtn.closest("fieldset");
            const nextId = nextBtn.dataset.next;
            const nextFs = nextId ? document.getElementById(nextId) : null;

            if (!nextFs) {
                // eslint-disable-next-line no-console
                console.error("Next fieldset not found. ID:", nextId);
                animating = false;
                return;
            }

            await transitionTo({ from: currentFs, to: nextFs, direction: "next" });

            currentStep = Math.min(currentStep + 1, totalSteps);
            setProgressBar(currentStep);
            return;
        }

        if (prevBtn) {
            e.preventDefault();

            if (animating) return;

            const currentFs = prevBtn.closest("fieldset");
            let previousFs = null;

            if (currentFs && currentFs.previousElementSibling) {
                if (currentFs.previousElementSibling.tagName === "FIELDSET") {
                    previousFs = currentFs.previousElementSibling;
                } else if (currentFs.previousElementSibling.closest) {
                    previousFs = currentFs.previousElementSibling.closest("fieldset");
                }
            }


            if (!previousFs || previousFs.tagName !== "FIELDSET") {
                // eslint-disable-next-line no-console
                console.error("Previous fieldset not found.");
                animating = false;
                return;
            }

            await transitionTo({ from: currentFs, to: previousFs, direction: "prev" });

            currentStep = Math.max(currentStep - 1, 1);
            setProgressBar(currentStep);
            return;
        }

        if (resetBtn) {
            e.preventDefault();

            hide(resetButton);

            if (animating) return;

            const currentFs = getCurrentVisibleFieldset();
            const firstFs = document.getElementById("step1");

            if (!firstFs) return;

            await transitionTo({ from: currentFs, to: firstFs, direction: "prev" });

            currentStep = 1;
            setProgressBar(currentStep);
        }
    });

    fieldsets.forEach((fs, idx) => {
        if (idx === 0) show(fs);
        else hide(fs);
    });

    hide(resetButton);
    setProgressBar(currentStep);
};

//// Course Content Page



////This is for the Javascript Q's

//function RHQ1Yes() {
//    document.getElementById("RHQ1YesInfo").style.display = "block";
//    document.getElementById("RHQ1NoInfo").style.display = "none";
//}
//function RHQ1No() {
//    document.getElementById("RHQ1YesInfo").style.display = "none";
//    document.getElementById("RHQ1NoInfo").style.display = "block";
//}
//function RHQ2Yes() {
//    document.getElementById("RHQ2YesInfo").style.display = "block";
//    document.getElementById("RHQ2NoInfo").style.display = "none";
//}
//function RHQ2No() {
//    document.getElementById("RHQ2YesInfo").style.display = "none";
//    document.getElementById("RHQ2NoInfo").style.display = "block";
//}
//function RHQ3Yes() {
//    document.getElementById("RHQ3YesInfo").style.display = "block";
//    document.getElementById("RHQ3NoInfo").style.display = "none";
//}
//function RHQ3No() {
//    document.getElementById("RHQ3YesInfo").style.display = "none";
//    document.getElementById("RHQ3NoInfo").style.display = "block";

//}

////Following is for a scroll-based fade in:


//$(document).ready(function () {
//    // set the element you want to fade in
//    var $elem = $('.content-block-fadein');

//    // set the opacity to 0 and the display to block
//    $elem.css({ opacity: 0, display: 'block' });

//    // use the window's scroll event to check when the element is visible
//    $(window).scroll(function () {
//        // get the distance between the top of the document and the top of the element
//        var dist = $elem.offset().top - $(window).height();

//        // check if the element is within the viewport
//        if ($(document).scrollTop() > dist && $(document).scrollTop() < $elem.offset().top + $elem.height()) {
//            // if it is, fade in the element over 1 second
//            $elem.stop().animate({ opacity: 1 }, 500);
//        } else {
//            // if it isn't, fade out the element over 1 second
//            $elem.stop().animate({ opacity: 0 }, 500);
//        }
//    }).scroll(); // trigger the scroll event on page load
//});

//$(document).ready(function () {
//    // set the element you want to animate
//    var $elem = $('.content-block-slide');

//    // set the height of the element to 0 and the display to block
//    $elem.css({ height: 0, display: 'block' });

//    // use the window's scroll event to check when the element is visible
//    $(window).scroll(function () {
//        // get the distance between the top of the document and the top of the element
//        var dist = $elem.offset().top - $(window).height();

//        // check if the element is within the viewport
//        if ($(document).scrollTop() > dist && $(document).scrollTop() < $elem.offset().top + $elem.height()) {
//            // if it is, slide down the element over 1 second
//            $elem.stop().animate({ height: $elem.children().outerHeight() }, 1000);
//        } else {
//            // if it isn't, slide up the element over 1 second
//            $elem.stop().animate({ height: 0 }, 1000);
//        }
//    }).scroll(); // trigger the scroll event on page load
//});

//function scrollTop(sender, args) {
//    if ((args.EventTarget.indexOf('$btnPrevious') > -1) || (args.EventTarget.indexOf('$btnContinue') > -1)) {
//        $('html, body').animate({
//            scrollTop: $('#PageContent').offset().top
//        }, 500);
//    }
//}

//function AjaxCompleted(sender, args) {
//    scrollTop(sender, args);
//    pageAccordions();

//}


////Following script is for the carousel

//let slideIndex = 1;
//showSlides(slideIndex);

//// Next/previous controls
//function plusSlides(n) {
//    showSlides(slideIndex += n);
//}

//// Thumbnail image controls
//function currentSlide(n) {
//    showSlides(slideIndex = n);
//}


//function showSlides(n) {
//    let i;
//    let slides = document.getElementsByClassName("RHmySlides");
//    let dots = document.getElementsByClassName("RHdot");
//    if (n > slides.length) { slideIndex = 1 }
//    if (n < 1) { slideIndex = slides.length }
//    for (i = 0; i < slides.length; i++) {
//        slides[i].style.display = "none";
//    }
//    for (i = 0; i < dots.length; i++) {
//        dots[i].className = dots[i].className.replace(" active", "");
//    }
//    slides[slideIndex - 1].style.display = "block";
//    dots[slideIndex - 1].className += " active";
//}

/* -----------------------------
   Utilities
------------------------------ */

function onReady(fn) {
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", fn);
    } else {
        fn();
    }
}

function getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function getRect(el) {
    return el.getBoundingClientRect();
}

function isInViewport(el) {
    if (!el) return false;

    const rect = getRect(el);
    const viewH = window.innerHeight || document.documentElement.clientHeight;

    // Roughly equivalent to the jQuery logic: element considered "active" when the scroll
    // position is between (elemTop - viewportHeight) and (elemTop + elemHeight)
    // Using rect: top <= viewH and bottom >= 0 means any overlap with viewport.
    return rect.top <= viewH && rect.bottom >= 0;
}

function setStyle(el, styleObj) {
    if (!el) return;

    Object.keys(styleObj).forEach(function (k) {
        el.style[k] = styleObj[k];
    });
}

/* -----------------------------
   RHQ Yes/No toggles (generic)
------------------------------ */

function togglePair(yesId, noId, isYes) {
    const yesEl = document.getElementById(yesId);
    const noEl = document.getElementById(noId);

    if (yesEl) yesEl.style.display = isYes ? "block" : "none";
    if (noEl) noEl.style.display = isYes ? "none" : "block";
}

function RHQ1Yes() { togglePair("RHQ1YesInfo", "RHQ1NoInfo", true); }
function RHQ1No() { togglePair("RHQ1YesInfo", "RHQ1NoInfo", false); }

function RHQ2Yes() { togglePair("RHQ2YesInfo", "RHQ2NoInfo", true); }
function RHQ2No() { togglePair("RHQ2YesInfo", "RHQ2NoInfo", false); }

function RHQ3Yes() { togglePair("RHQ3YesInfo", "RHQ3NoInfo", true); }
function RHQ3No() { togglePair("RHQ3YesInfo", "RHQ3NoInfo", false); }

/* -----------------------------
   Scroll-based fade + slide
   (replaces jQuery animate)
------------------------------ */

function initScrollEffects() {
    const fadeElems = Array.prototype.slice.call(document.querySelectorAll(".content-block-fadein"));
    const slideElems = Array.prototype.slice.call(document.querySelectorAll(".content-block-slide"));

    // Initial state to match old code intent
    fadeElems.forEach(function (el) {
        setStyle(el, {
            opacity: "0",
            display: "block",
            transition: "opacity 500ms ease"
        });
    });

    slideElems.forEach(function (el) {
        setStyle(el, {
            height: "0px",
            overflow: "hidden",
            display: "block",
            transition: "height 1000ms ease"
        });
    });

    function applyFade() {
        fadeElems.forEach(function (el) {
            el.style.opacity = isInViewport(el) ? "1" : "0";
        });
    }

    function applySlide() {
        slideElems.forEach(function (el) {
            if (isInViewport(el)) {
                // Equivalent to: height = $elem.children().outerHeight()
                // Use scrollHeight for the element's content height.
                const target = el.scrollHeight;
                el.style.height = String(target) + "px";
            } else {
                el.style.height = "0px";
            }
        });
    }

    function applyAll() {
        applyFade();
        applySlide();
    }

    // Throttle scroll via rAF
    let ticking = false;

    function onScrollOrResize() {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(function () {
            applyAll();
            ticking = false;
        });
    }

    window.addEventListener("scroll", onScrollOrResize, { passive: true });
    window.addEventListener("resize", onScrollOrResize);

    // Trigger on load, similar to .scroll() call in jQuery
    applyAll();
}

/* -----------------------------
   Scroll-to-top on wizard nav
   (replaces $('html, body').animate)
------------------------------ */

function scrollToPageContentTop() {
    const target = document.getElementById("PageContent");
    if (!target) return;

    const top = target.getBoundingClientRect().top + getScrollTop();

    // Smooth scroll with fallback
    try {
        window.scrollTo({ top: top, behavior: "smooth" });
    } catch (e) {
        window.scrollTo(0, top);
    }
}

function scrollTop(sender, args) {
    const eventTarget = args && args.EventTarget ? String(args.EventTarget) : "";

    if (eventTarget.indexOf("$btnPrevious") > -1 || eventTarget.indexOf("$btnContinue") > -1) {
        scrollToPageContentTop();
    }
}

function AjaxCompleted(sender, args) {
    scrollTop(sender, args);

    if (typeof pageAccordions === "function") {
        pageAccordions();
    }
}

/* -----------------------------
   Carousel (largely unchanged)
------------------------------ */

let slideIndex = 1;

function plusSlides(n) {
    showSlides(slideIndex += n);
}

function currentSlide(n) {
    showSlides(slideIndex = n);
}

function showSlides(n) {
    const slides = document.getElementsByClassName("RHmySlides");
    const dots = document.getElementsByClassName("RHdot");

    if (!slides || slides.length === 0) return;

    if (n > slides.length) slideIndex = 1;
    if (n < 1) slideIndex = slides.length;

    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }

    for (let j = 0; j < dots.length; j++) {
        dots[j].className = dots[j].className.replace(" active", "");
    }

    slides[slideIndex - 1].style.display = "block";

    if (dots[slideIndex - 1]) {
        dots[slideIndex - 1].className += " active";
    }
}

/* -----------------------------
   Init
------------------------------ */

onReady(function () {
    initScrollEffects();
    showSlides(slideIndex);
});


//Script #5 - Image Text Reveal
//Simple function that sets an element�s opacity to 1, used to reveal text when an image is interacted with.

function revealText() {
    var textElement = document.getElementById('imageText');
    textElement.style.opacity = '1';
}


//Script #6 - Horizontal Carousel Button Scroller
//Adds click-based scrolling to horizontal carousels with ".prev-btn" and ".next-btn".
//Uses a MutationObserver so it works on dynamically added carousels too.

const observer = new MutationObserver(() => {
    document.querySelectorAll(".training-carousel-container").forEach((carouselContainer) => {
        const container = carouselContainer.querySelector(".linkflexcontainer");
        const prevBtn = carouselContainer.querySelector(".prev-btn");
        const nextBtn = carouselContainer.querySelector(".next-btn");

        // Avoid double binding
        if (!container || prevBtn.dataset.bound) return;

        let scrollAmount = container.clientWidth * 0.8;
        let isScrollingByButton = false;

        function scrollToPosition(offset, event) {
            event.preventDefault();
            event.stopPropagation();
            if (isScrollingByButton) return;
            isScrollingByButton = true;
            container.style.scrollSnapType = "none";
            container.scrollBy({ left: offset, behavior: "smooth" });
            setTimeout(() => {
                isScrollingByButton = false;
                container.style.scrollSnapType = "x mandatory";
            }, 500);
        }

        prevBtn.addEventListener("click", function (e) {
            scrollToPosition(-scrollAmount, e);
        });
        nextBtn.addEventListener("click", function (e) {
            scrollToPosition(scrollAmount, e);
        });

        prevBtn.dataset.bound = "true"; // mark as initialized
        nextBtn.dataset.bound = "true";
    });
});

// Observe the document body for new elements
observer.observe(document.body, {
    childList: true,
    subtree: true,
});


//Script #7 - Simple Answer Buttons Quiz
//Handles interactive Q&A blocks using .answerbutton elements.
//Shows correct/incorrect feedback boxes and visually styles the selected button.

document.body.addEventListener('click', function (e) {
    const button = e.target.closest('.answerbutton');
    if (!button) return;

    const questionId = button.getAttribute('data-question-id');
    const selectedId = button.id;
    const correctId = button.getAttribute('data-correct-id');
    const isCorrect = button.getAttribute('data-correct') === 'true';

    const container = document.getElementById(`${questionId}Container`);
    if (container && container.getAttribute('data-locked') === 'true') return;

    selectAnswer(questionId, isCorrect, selectedId, correctId);

    if (container && isCorrect) {
        container.setAttribute('data-locked', 'true');
    }
});

function selectAnswer(questionId, correct, selectedId, correctId) {
    const buttons = document.querySelectorAll(`.answerbutton[data-question-id="${questionId}"]`);
    buttons.forEach(btn => {
        btn.classList.remove("correct-selected", "incorrect-selected");
    });

    const correctBox = document.getElementById(`${questionId}YesInfo`);
    const incorrectBox = document.getElementById(`${questionId}NoInfo`);

    if (correct) {
        correctBox.style.display = "block";
        incorrectBox.style.display = "none";
        document.getElementById(correctId).classList.add("correct-selected");
    } else {
        correctBox.style.display = "none";
        incorrectBox.style.display = "block";
        document.getElementById(selectedId).classList.add("incorrect-selected");
    }
}


//Script #8 - Full Quiz System (Single, Multiple, Open Questions)
//Complex quiz script, handling multiple data types. 

(() => {
    // === CONFIG ===
    const RESET_RELOAD_PAGE = false;

    // Store original HTML per question element
    const originalHTML = new WeakMap();

    // Save original HTML for existing questions
    document.querySelectorAll('.question').forEach(q => originalHTML.set(q, q.innerHTML));

    // Watch for dynamically-added questions
    const mo = new MutationObserver(mutations => {
        for (const m of mutations) {
            m.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;
                if (node.matches && node.matches('.question')) {
                    if (!originalHTML.has(node)) originalHTML.set(node, node.innerHTML);
                } else if (node.querySelectorAll) {
                    node.querySelectorAll('.question').forEach(q => {
                        if (!originalHTML.has(q)) originalHTML.set(q, q.innerHTML);
                    });
                }
            });
        }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Centralized click handler (delegation)
    document.addEventListener('click', (event) => {
        const submitBtn = event.target.closest('.submit-btn');
        const resetBtn = event.target.closest('.reset-btn');

        if (submitBtn) {
            event.preventDefault();
            const questionDiv = submitBtn.closest('.question');
            if (!questionDiv) return;

            if (!originalHTML.has(questionDiv)) originalHTML.set(questionDiv, questionDiv.innerHTML);

            const checkboxes = questionDiv.querySelectorAll('input[type="checkbox"]');
            const radios = questionDiv.querySelectorAll('input[type="radio"]');
            const feedbackCorrect = questionDiv.querySelector('.feedback.correct');
            const feedbackIncorrect = questionDiv.querySelector('.feedback.incorrect');
            const fallbackFeedback = questionDiv.querySelector('.feedback:not(.correct):not(.incorrect)');

            // Hide all feedbacks first (but don't clear classes)
            if (feedbackCorrect) feedbackCorrect.style.display = 'none';
            if (feedbackIncorrect) feedbackIncorrect.style.display = 'none';
            if (fallbackFeedback) fallbackFeedback.style.display = 'none';

            const type = questionDiv.dataset.type || 'multiple';

            // === MULTIPLE (checkbox) ===
            if (type === 'multiple') {
                const selected = Array.from(checkboxes).filter(cb => cb.checked).map(cb => cb.value);
                const correctAnswers = (questionDiv.dataset.correct || '')
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean);

                if (selected.length === 0) {
                    if (fallbackFeedback) {
                        fallbackFeedback.innerHTML = questionDiv.dataset.feedbackEmpty || 'Please select an option before submitting.';
                        fallbackFeedback.style.display = 'block';
                        fallbackFeedback.classList.add('warning');
                    }
                    return;
                }

                const isCorrect = selected.length === correctAnswers.length &&
                    selected.every(val => correctAnswers.includes(val));

                if (isCorrect) {
                    if (feedbackCorrect) {
                        feedbackCorrect.style.display = 'block';
                        feedbackCorrect.classList.add('correct');
                    }
                    checkboxes.forEach(cb => cb.disabled = true);
                    submitBtn.disabled = true;
                    const r = questionDiv.querySelector('.reset-btn');
                    if (r) r.style.display = 'none'; // hide reset only after correct
                    questionDiv.classList.add('answered-correct');
                } else {
                    if (feedbackIncorrect) {
                        feedbackIncorrect.style.display = 'block';
                        feedbackIncorrect.classList.add('incorrect');
                    }
                    const r = questionDiv.querySelector('.reset-btn');
                    if (r) r.style.display = 'inline-block';
                }

                // === SINGLE (radio, one correct answer) ===
            } else if (type === 'single') {
                const selectedRadio = Array.from(radios).find(rb => rb.checked);
                const correctAnswer = (questionDiv.dataset.correct || '').trim();

                if (!selectedRadio) {
                    if (fallbackFeedback) {
                        fallbackFeedback.innerHTML = questionDiv.dataset.feedbackEmpty || 'Please select an option before submitting.';
                        fallbackFeedback.style.display = 'block';
                        fallbackFeedback.classList.add('warning');
                    }
                    return;
                }

                if (selectedRadio.value === correctAnswer) {
                    if (feedbackCorrect) {
                        feedbackCorrect.style.display = 'block';
                        feedbackCorrect.classList.add('correct');
                    }
                    radios.forEach(rb => rb.disabled = true);
                    submitBtn.disabled = true;
                    const r = questionDiv.querySelector('.reset-btn');
                    if (r) r.style.display = 'none';
                    questionDiv.classList.add('answered-correct');
                } else {
                    if (feedbackIncorrect) {
                        feedbackIncorrect.style.display = 'block';
                        feedbackIncorrect.classList.add('incorrect');
                    }
                    const r = questionDiv.querySelector('.reset-btn');
                    if (r) r.style.display = 'inline-block';
                }

                // === OPEN (freeform text or custom) ===
            } else if (type === 'open') {
                const selectedRadio = Array.from(radios).find(rb => rb.checked);
                if (!selectedRadio) {
                    if (fallbackFeedback) {
                        fallbackFeedback.innerHTML = questionDiv.dataset.feedbackEmpty || 'Please select an option before submitting.';
                        fallbackFeedback.style.display = 'block';
                        fallbackFeedback.classList.add('warning');
                    }
                    return;
                }
                if (feedbackCorrect) {
                    feedbackCorrect.style.display = 'block';
                    feedbackCorrect.classList.add('correct');
                }
                radios.forEach(rb => rb.disabled = true);
                submitBtn.disabled = true;
                questionDiv.classList.add('answered-correct');
            }
        }

        if (resetBtn) {
            const questionDiv = resetBtn.closest('.question');
            if (!questionDiv) return;

            if (RESET_RELOAD_PAGE) {
                window.location.reload();
                return;
            }

            const orig = originalHTML.get(questionDiv);
            if (orig) {
                questionDiv.innerHTML = orig;
            } else {
                // Fallback manual reset
                questionDiv.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false; cb.disabled = false; });
                questionDiv.querySelectorAll('input[type="radio"]').forEach(rb => { rb.checked = false; rb.disabled = false; });
                questionDiv.querySelectorAll('.feedback').forEach(fb => { fb.style.display = 'none'; fb.classList.remove('correct', 'incorrect', 'warning'); });
                const submit = questionDiv.querySelector('.submit-btn'); if (submit) submit.disabled = false;
                resetBtn.style.display = 'none';
            }
        }
    });
})();


//Script #9 - Modal System
//Controls modals triggered by .modal-trigger elements.

document.addEventListener("click", function (e) {
    // === Open modal ===
    const trigger = e.target.closest(".modal-trigger");
    if (trigger) {
        const targetModalId = trigger.getAttribute("data-target");
        const targetModal = document.getElementById(targetModalId);
        if (targetModal) {
            // Remove 'active' from all triggers
            document.querySelectorAll('.modal-trigger').forEach(btn => btn.classList.remove('active'));

            // Add 'active' and 'clicked' to the clicked trigger
            trigger.classList.add('active', 'clicked');

            // Show modal
            targetModal.classList.add("show");
        }
        return;
    }

    // === Close modal via "X" ===
    if (e.target.classList.contains("close")) {
        const modal = e.target.closest(".modal");
        if (modal) {
            modal.classList.remove("show");
            // Remove 'active' from all triggers
            document.querySelectorAll('.modal-trigger').forEach(btn => btn.classList.remove('active'));
        }
        return;
    }

    // === Close modal by clicking background ===
    if (e.target.classList.contains("modal")) {
        e.target.classList.remove("show");
        // Remove 'active' from all triggers
        document.querySelectorAll('.modal-trigger').forEach(btn => btn.classList.remove('active'));
    }
});

// Optional: allow ESC key to close modals
document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        document.querySelectorAll(".modal.show").forEach(modal => {
            modal.classList.remove("show");
        });
        // Remove 'active' from all triggers
        document.querySelectorAll('.modal-trigger').forEach(btn => btn.classList.remove('active'));
    }
});


//Script #10 - Scroll-Triggered Reveal Animation
//Animates Elements with .STAnimate when they enter the viewport

document.addEventListener("DOMContentLoaded", () => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("STVisible");
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.2 }
    );

    const observeElements = (elements) => {
        elements.forEach(el => {
            if (!el.classList.contains("STVisible")) {
                observer.observe(el);
            }
        });
    };

    // Initial observation
    observeElements(document.querySelectorAll(".STAnimate"));

    // MutationObserver to detect new elements
    const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    if (node.classList.contains("STAnimate")) {
                        observeElements([node]);
                    } else if (typeof node.querySelectorAll === "function") {
                        const nested = node.querySelectorAll(".STAnimate");
                        if (nested.length) {
                            observeElements(nested);
                        }
                    }
                }
            });
        });
    });

    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
});